import React from "react";
import MirsTable from "components/general/table/Table";
import {boulderBoulderColumns, boulderLeadColumns, leadColumns } from "./Columns";
import PageHeader from "components/common/PageHeader";
import ProgressionRule from "components/common/ProgressionRule";
import { isLeadKRA, isQual, isFinals } from "components/sports/clb/helper/ClbHelpers";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import Label from "components/general/Label";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import NotAvailable from "components/common/NotAvailable";



const Results = ({data, mirs_competition, mirs_language, mirs_rsc, breakPoint}) => {

    const filtersQualRule = {
        type: ['QUALIFICATION'],
        code: ['QUAL_RULE']
    };

    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;

    const isStartList = isStartListStatus(resultStatus);
    const isLive = isLiveStatus(resultStatus);
    const isFinished = isFinishedStatus(resultStatus);

    const isMobile = breakPoint === "sm" || breakPoint === "xs" 

    const currents = data?.results?.extendedInfos?.filter(ei => ei?.ei_code === 'CURRENT')?.map(ei => ({code: ei?.ei_value, pos: ei?.ei_pos}))

    const hasRouteA = data?.results?.items?.find(item => item?.extendedResults?.find(ext => ext?.er_pos === 'A'))
    const hasRouteB = data?.results?.items?.find(item => item?.extendedResults?.find(ext => ext?.er_pos === 'B'))

    const caption = (<CaptionTable
      leftCol={<span className="fw-bold"><Label data={isStartList ? 'HeaderStartList': 'HeaderResults'} /></span>}
      rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />} />)
    
    const getColumns = () => {
        let columns = [];
        if (isLeadKRA(mirs_rsc)) {
          columns = leadColumns(hasRouteA, hasRouteB);
        }
        return columns;    
    }

    const getInitialSortBy = () => {
      let initialSortBy = []
      if(isLeadKRA(mirs_rsc)){ 
          initialSortBy = isStartList ? [{ id: 'StartOrder', desc: false }] : [{ id: 'Rank', desc: false }];
      }      
      return initialSortBy;
    }

    const getHiddenColumns = () => {
      let hiddenColumns = []
      let routes = isQual(mirs_rsc) ? [] : ['RouteA', 'RouteB'];
      let qualMark = isFinals(mirs_rsc) ? ['QualMark'] : []
      let scoreTime = isFinals(mirs_rsc) ? ['Result'] : ['ScoreTime']
      if(isLeadKRA(mirs_rsc)){
        if (isMobile){
          hiddenColumns = isStartList ? ['StartOrder', 'Rank', 'QualMark', 'RouteA', 'RouteB', 'Result', 'ScoreTime'] : ['StartOrder', 'Bib', ...routes, ...qualMark, ...scoreTime];
        } else {
          hiddenColumns = isStartList ? ['qualMark','Rank', 'RouteA', 'RouteB', 'Result', 'ScoreTime'] : isLive ? [...routes, ...qualMark, ...scoreTime] : ['StartOrder', ...routes, ...qualMark, ...scoreTime];
        }
      }

      return hiddenColumns;
    }

    const getCurrentIndicator = (row) => {
      let out = '';
      if(isLeadKRA(mirs_rsc)){
        const isCurrent = currents ? currents?.find(c => c?.code === row.original.participant.code) : undefined;
        out =  {className: isCurrent ? 'currentIndicator' : ''}
      }
      return out  
    }

    const getCellCurrentIndicator = (cellInfo) => {
      let out = ''
      return out  
    }

    const getColumnProps = (columnInfo) => {
    }

    return <>
            
            <PageHeader data={data} />
            
            <ProgressionRule key="progress-component" data={data?.config} filter={filtersQualRule} itemData={'value'} />
            
            { data?.results?.items && 
            <MirsTable
                id={`mirs-table-result-${mirs_rsc}`}
                sortable={!isMobile}
                caption={caption}
                data={data?.results?.items}
                columns={getColumns()}
                keyRow={"participant-code"}
                initialSortBy={getInitialSortBy()}
                hiddenColumns={getHiddenColumns()}
                getRowProps={row => { return getCurrentIndicator(row) }}
                getCellProps={cellInfo => {return getCellCurrentIndicator(cellInfo) }}
                getColumnProps={getColumnProps() }
            />
            }

    </>
}

export default Results;

